import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GetMatchEloPointsModel } from 'models/matches';

@Component({
    selector: 'app-match-box-elo-points',
    templateUrl: './match-box-elo-points.component.html',
    styleUrls: ['./match-box-elo-points.component.scss'],
    imports: [MatTooltip, NgTemplateOutlet, DecimalPipe, TranslateModule],
})
export class MatchBoxEloPointsComponent {
    @Input() elo1: GetMatchEloPointsModel;
    @Input() elo2: GetMatchEloPointsModel;
    @Input() expectedOutcome: number;
}
